import { reducer as formReducer } from 'redux-form';

import { captureException } from '@skippay/core/global/errorTracking';
import { CLIENT_PLATFORM, SCREEN_ORIENTATION } from '@skippay/core/modules/clientInfo';
import { createReduxStore } from '@skippay/core/utils/reduxUtils';

import clientInfoMiddleware from './clientInfoMiddleware.web';
import history from './history';

const getStore = (apolloClient, modules) => {
	return createReduxStore(
		{
			enhancers: [clientInfoMiddleware],
			modules,
			reducers: {
				form: formReducer,
			},
		},
		{
			initialState: {
				clientInfo: {
					isDarkMode: false,
					isInitialized: true,
					isLoading: false,
					platform: CLIENT_PLATFORM.WEB,
					screenOrientation: SCREEN_ORIENTATION.PORTRAIT,
					screenSize: '',
				},
			},
			sagaOptions: { context: { apolloClient, history }, onError: captureException },
		}
	);
};

export default getStore;
